import { render, staticRenderFns } from "./mpvue-calendar.vue?vue&type=template&id=cd84abe4&"
import script from "./mpvue-calendar.vue?vue&type=script&lang=js&"
export * from "./mpvue-calendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports